"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderBookingAvailability = exports.ActivityListItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const ProgressiveImage_1 = __importDefault(require("../../../common/components/Other/ProgressiveImage"));
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const Item = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: space-between;
  border-radius: 5px;
  padding: 5px;
  margin: 15px 0;
  cursor: pointer;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  .progressive-image {
    height: 120px;
    width: 120px;
    flex-shrink: 0;
    border-radius: 7px;

    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }
`;
const ItemImage = styled_components_1.default.div `
  height: 120px;
  width: 120px;
  flex-shrink: 0;
  border-radius: 7px;

  background: linear-gradient(
    12deg,
    ${props => props.theme.palette.mainAppColor.dark} 5%,
    ${props => props.theme.palette.mainAppColor.light} 25%,
    ${props => props.theme.palette.mainAppColor.main} 100%
  );

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${props => {
    if (props.src) {
        return props.src;
    }
    return null;
}};

  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }
`;
const ItemContent = styled_components_1.default.div `
  flex-grow: 1;
  padding: 10px 0 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 1rem;
`;
const TitleWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;

  img {
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 8px;
  }

  p {
    margin-top: 0px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0px;
  }
`;
const PlaceAndTime = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  gap: 5px;
  font-size: 0.8rem;
`;
const Place = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-weight: 200;
  color: #807e7e;

  svg {
    font-size: 0.8rem;
    margin-right: 2px;
    position: relative;
    bottom: 1px;
  }

  p {
    margin: 0px;
    max-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }
`;
const Time = styled_components_1.default.div `
  font-weight: 200;
  color: #807e7e;
  flex-shrink: 0;

  span {
    white-space: nowrap;
  }
`;
const Book = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: 0.8rem;

  .booking-circle {
    height: 8px;
    width: 8px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;

    &.green {
      background-color: #4cd964;
    }

    &.red {
      background-color: #ff3b30;
    }

    &.blue {
      background-color: #5ac8fa;
    }

    &.yellow {
      background-color: #ffcc00;
    }
  }

  &.hidden {
    visibility: hidden;
  }
`;
const ActivityListItem = ({ content, currentLocale, timezone, location, history, disableParticipateButton, disabledParticipateButtonText, }) => {
    const renderListItem = () => (react_1.default.createElement(Item, { className: "list-item", onClick: () => {
            if (content.type === 'convention_activity') {
                const redirectLocation = `${location.pathname}/${content.contentId}`;
                history.push({
                    pathname: redirectLocation,
                    search: location.search,
                });
                setTimeout(() => {
                    helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                        content,
                        redirectOnClose: location.pathname,
                        disableParticipateButton,
                        disabledParticipateButtonText,
                    });
                }, 0);
                return;
            }
            const transitionToItemDetail = () => {
                const redirectLocation = content.deeplink
                    ? new URL(content.deeplink).pathname
                    : `/directory/page/${content.title.toLowerCase().replace(/ /g, '-')}`;
                history.push({
                    pathname: redirectLocation,
                    search: location.search,
                });
            };
            transitionToItemDetail();
            setTimeout(() => {
                helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                    content,
                    redirectOnClose: location.pathname,
                    disableParticipateButton,
                    disabledParticipateButtonText,
                });
            }, 0);
        } },
        content && content.smallImage ? (react_1.default.createElement(ProgressiveImage_1.default, { image: content.smallImage, alt: content.title, imageClass: "progressive-image" })) : (react_1.default.createElement(ItemImage, { className: "item-image" })),
        react_1.default.createElement(ItemContent, { className: "item-content" },
            react_1.default.createElement(PlaceAndTime, { className: "place-time" },
                react_1.default.createElement(Place, null, content.placeName && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Place_1.default, null),
                    react_1.default.createElement(Typography_1.default, { variant: "body2" }, content.placeName)))),
                (content.type === 'activity' || content.type === 'convention_activity') && (react_1.default.createElement(react_1.default.Fragment, null, renderActivityTime(content, currentLocale, timezone)))),
            react_1.default.createElement(TitleWrapper, { className: "title" },
                content.type === 'convention_activity' && react_1.default.createElement("img", { src: "/images/other/convention.svg", alt: "convention icon" }),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, content.title)),
            renderBookingAvailability(content))));
    return renderListItem();
};
exports.ActivityListItem = ActivityListItem;
function renderActivityTime(content, currentLocale, timezone) {
    if (!content.showStartTime && !content.showEndTime) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, currentLocale, timezone).time;
    const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.end, currentLocale, timezone).time;
    // const startTime1 = Helpers.getHourFromDate( content.start, timezone );
    // const endTime1 = Helpers.getHourFromDate( content.end, timezone );
    //
    // const startTime2 = Helpers.getDateFromStringDependingLocale( content.start, currentLocale, timezone ).time;
    // const endTime2 = Helpers.getDateFromStringDependingLocale( content.end, currentLocale, timezone ).time;
    // console.log( "title", content.title );
    // console.log( "startTime current", startTime );
    // console.log( "startTime old", startTime1 );
    // console.log( "startTime current w timezone", startTime2 );
    //
    // console.log( "endTime current", endTime );
    // console.log( "endTime old", endTime1 );
    // console.log( "endTime current w timezone", endTime2 );
    //
    // console.log( "---------" );
    return (react_1.default.createElement(Time, { className: "right-align grey-text text-lighten-1" },
        content.showStartTime && content.showEndTime && (react_1.default.createElement(Typography_1.default, { variant: "body2" },
            startTime,
            " - ",
            endTime)),
        content.showStartTime && !content.showEndTime && react_1.default.createElement(Typography_1.default, { variant: "body2" }, startTime)));
}
function renderBookingAvailability(content) {
    if (!content.bookable) {
        return react_1.default.createElement(Book, { className: "hidden" }, "a");
    }
    const bookingState = content.availability ? content.availability.availabilityState : 'available';
    const bookingButtonText = content.availability
        ? content.availability.textsForDisplay.availabilityState
        : i18n_js_1.default.t('book_now');
    let bookingColor = '';
    switch (content.availability && content.availability.availabilityState) {
        case 'available':
            bookingColor = 'green';
            break;
        case 'sold_out':
        case 'not_bookable_anymore':
        case 'not_yet_bookable':
        case 'disabled':
        case 'canceled':
            bookingColor = 'red';
            break;
        case 'user_has_active_booking':
            bookingColor = 'blue';
            break;
        case 'few_places_left':
            bookingColor = 'yellow';
            break;
        default:
            bookingColor = 'green';
    }
    return (react_1.default.createElement(Book, { state: bookingState, className: "booking-status" },
        react_1.default.createElement("div", { className: `booking-circle ${bookingColor}` }),
        react_1.default.createElement(Typography_1.default, { variant: "body2" }, bookingButtonText)));
}
exports.renderBookingAvailability = renderBookingAvailability;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ActivityListItem));
